import { commits, getters } from '/@/modules/core/app/helpers/store';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { Currency } from '/@/modules/predefined/models/Currency';
import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { PredefinedCurrency } from '@/modules/predefined/enums/PredefinedCurrency';

export class CurrencyService extends BaseEntityService {
  getRoute() {
    return Route.PREDEFINED_CURRENCIES;
  }

  getModel() {
    return Currency;
  }

  async getItems() {
    const items = await this.getEntities();
    commits.predefined.setCurrencies(items);
    return items;
  }

  static getDefaultCurrency() {
    return (
      getters.auth.getUser()?.currentEstate?.jurisdiction.country.currencyId ??
      PredefinedCurrency.CAD.id
    );
  }
}

export default new CurrencyService();
